/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { IntegrationConfig } from '../models/IntegrationConfig';

export class CreateIntegrationResponse {
  'integration': IntegrationConfig;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "integration",
      "baseName": "integration",
      "type": "IntegrationConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateIntegrationResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

